// extracted by mini-css-extract-plugin
export default {"button":"LikesIcon-module__button","icon":"LikesIcon-module__icon","count":"LikesIcon-module__count"};